import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import Save from '@mui/icons-material/Save'
import { isDisabled, isSubmitting } from './utils'
import LoadingButton from '@carsys/ui/src/LoadingButton'
import { LoadingButtonProps } from '@mui/lab'

interface SubmitButtonProps extends LoadingButtonProps {
  children: string
  isNewItem?: boolean // initial values will be treated as dirty, allowing user to click save with unmodified initial values
}

export function SubmitButton({ children, isNewItem, ...props }: SubmitButtonProps) {
  const formik = useFormikContext<any>()
  const { t, i18n } = useTranslation()

  const content = i18n.exists(children) ? t(children) : children

  return (
    <LoadingButton loading={isSubmitting(formik)} disabled={isDisabled(formik, isNewItem)} data-testid='btn-submit' {...props}>
      {content}
    </LoadingButton>
  )
}

SubmitButton.defaultProps = {
  children: 'Form.Buttons.Submit',
  color: 'primary',
  startIcon: <Save />,
  type: 'submit',
  variant: 'contained'
}
